<form [formGroup]="searchForm">
   <div class="card border-dark">
      <div class="card-header">
         <b>{{ 'Search' | translate }}</b>
      </div>
      <div class="card-body">
         <div class="form-row">
            <div class="col-md-6 md-form form-group">
               <lib-select
                  [elemList]="elemList"
                  [header]="'Country' | translate"
                  [options]="countries"
                  [field]="'name'"
                  [required]="false"
                  [load]="loadCountryObs"
                  [chooseStr]="'Choose' | translate"
                  [myName]="'country'"
                  [myGroup]="searchForm"
               >
               </lib-select>
            </div>
         </div>
         <div class="form-row">
            <div class="col-md-12 md-form form-inline">
               <button
                  type="button"
                  class="btn btn-primary"
                  (click)="onSearch()"
                  [disabled]="searchForm.invalid"
               >
                  {{ 'Search' | translate }}
               </button>
            </div>
         </div>
      </div>
   </div>
</form>
<lib-table
   [label]="'Records without status' | translate"
   [headers]="headers"
   [readOnly]="true"
   [readOnlyFilter]="'inQueue'"
   [codes]="codes"
   [rows]="records"
   [headerButtons]="[resendSelectedButtonText]"
   (headerEvent)="onButtonClick($event)"
   (checkEvent)="onCheckClick($event)"
>
</lib-table>
<lib-modal [handler]="confirmHandler" (button)="onResendConfirmed($event)"></lib-modal>
